import { createContext, ReactNode, useMemo, useState } from 'react';
import { SelectedFiltersContextType } from '../types/context';
import { FullscreenReferenceType, SelectedFilter } from '../types/types';

//TODO: All values and functions from this context should be in DetailFilterContext
// I had to move them to a separate context outside of Route because of a react-router bug, which causes Route content to be unmounted and mounted again sometimes
// Should be moved back to DetailFilterContext after updating react-router

const defaultValues: SelectedFiltersContextType = {
  fullscreenReference: null,
  selectedFilters: [],
  popoverFilters: [],
  setFullscreenReference: () => {
    throw new Error('setFullscreenReference must be implemented');
  },
  setPopoverFilters: () => {
    throw new Error('setPopoverFilters must be implemented');
  },
  setSelectedFilters: () => {
    throw new Error('setSelectedFilters must be implemented');
  },
};

export const SelectedFiltersContext =
  createContext<SelectedFiltersContextType>(defaultValues);

const SelectedFiltersContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [fullscreenReference, setFullscreenReference] =
    useState<FullscreenReferenceType | null>(null);
  const [selectedFilters, setSelectedFilters] = useState<SelectedFilter[]>(
    defaultValues.selectedFilters
  );
  const [popoverFilters, setPopoverFilters] = useState<any[]>([]);

  /*CONTEXT VALUE*/
  const value = useMemo(
    () => ({
      fullscreenReference,
      selectedFilters,
      popoverFilters,
      setFullscreenReference,
      setSelectedFilters,
      setPopoverFilters,
    }),
    [
      fullscreenReference,
      selectedFilters,
      popoverFilters,
      setFullscreenReference,
      setSelectedFilters,
      setPopoverFilters,
    ]
  );

  return (
    <SelectedFiltersContext.Provider value={value}>
      {children}
    </SelectedFiltersContext.Provider>
  );
};

export default SelectedFiltersContextProvider;
